import { createAsyncThunk } from '@reduxjs/toolkit'
import { createPaymentToken } from 'src/utils/payment'
import { isObjectEmpty } from 'src/utils/object'
import { postStripeChargesApi } from 'src/services/oms'
import { MetaStateInReducer } from 'src/redux/meta'
import { postLogApi } from '@jarvis.oddle/core/api/newrelic/client'
import { API_ROOT as DEFAULT_APP_API_ROOT, origin } from 'config/universal'

const createPaymentTokenApi = async (payload) => {
  const { token, tokenError } = await createPaymentToken(payload)
  if (!isObjectEmpty(tokenError)) {
    throw tokenError
  }

  return token
}

export const createPaymentTokenAction = createAsyncThunk(
  '@paymentProcess/createPaymentToken',
  async ({
    values,
    redirectUrl,
    selectedPaymentMethod,
    stripe,
    stripeElement,
    newStripeApi,
    isFullyPaidByVoucher,
    isEnabledCustomerSaveCreditCardOnStripe,
    selectedSavedCreditCard,
    storeOrderId
  }: {
    values
    redirectUrl
    selectedPaymentMethod
    stripe
    stripeElement
    newStripeApi
    isFullyPaidByVoucher
    isEnabledCustomerSaveCreditCardOnStripe
    selectedSavedCreditCard
    storeOrderId
  },
    { rejectWithValue, getState }) => {
    try {
      const state = getState() as MetaStateInReducer
      const { features: { enableStripePaymentElement }, countryCode } = state['@meta'].detailMenuSite.data
      return createPaymentTokenApi({
        values,
        redirectUrl,
        selectedPaymentMethod,
        stripe,
        stripeElement,
        newStripeApi,
        isFullyPaidByVoucher,
        isEnabledCustomerSaveCreditCardOnStripe,
        selectedSavedCreditCard,
        enableStripePaymentElement,
        country: countryCode
      })
    } catch (err) {
      postLogApi({
        origin,
        apiRoot: DEFAULT_APP_API_ROOT,
        payload: {
          message: `[FESC] Error create payment token for ${
            storeOrderId
          } with error ${JSON.stringify(err)}`
        }
      }).catch((e) => console.error(`[next_error_handling] ${e}`))
      return rejectWithValue(err)
    }
  }
)

export const postStripeChargesAction = createAsyncThunk(
  '@paymentProcess/postStripeCharges',
  async (
    {
      sourceId,
      storeOrderId
    }: {
      sourceId: string
      storeOrderId: string
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await postStripeChargesApi({
        sourceId,
        storeOrderId
      })
      return response.data
    } catch (err) {
      console.log(err)
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data)
    }
  }
)
